import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findengineerGoods = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v2/engineer_goods?` + params,
        method: 'GET'
    })
}

export const findClassifyAll = () => {
    return request({
        url: `${baseUrl}/joins-product/v2/engineer_classify/select`,
        method: 'GET'
    })
}

export const addEngineerGoods = (data) => {
    return request({
        url: `${baseUrl}/joins-product/v2/engineer_goods`,
        method: 'POST',
        data: data
    })
}

export const editEngineerGoods = (data) => {
    return request({
        url: `${baseUrl}/joins-product/v2/engineer_goods`,
        method: 'PUT',
        data: data
    })
}

export const delEngineerGoods = (ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-product/v2/engineer_goods//${temp}`,
        method: 'DELETE'
    })
}
export const soldIn = (ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-product/v2/engineer_goods/sold_in/${temp}`,
        method: 'PUT'
    })
}
export const soldOut = (ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-product/v2/engineer_goods/sold_out/${temp}`,
        method: 'PUT'
    })
}